// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"642":"08294a4f8138630d2b7a","852":"1eb0dc738b061263fc59"}[chunkId] + ".js";
};